<template>
  <div class="question">
    <img src="../assets/images/debug/home.jpg" />
   </div>
</template>
<script>
import Utils from '../utils'

export default {
  data() {
    return {
      pcImages: new Array(6).fill('').map((item, index) => {
        return require(`../assets/images/debug/0${index + 3}.jpg`)
      })
    }
  },
  components: {
  },
  mounted() {
    if (Utils.isPc()) {
      Utils.lazyloadImages('.pc-container .lazyload')
      setTimeout(() => {
        Utils.lazyloadImages('.mobile-container .lazyload')
      }, 1000)
      return
    }
  },
  methods: {
  }
}
</script>
<style>
.question{
  width: 100%;
  position: relative;
}
img{
  width: 100%;
}
.button-submit{
  width: 42.343vw;
  left: 26.64vw;
  top: 65%;
}
.button-left, .button-right{
  width: 20%;
  top: 33%;
}
.button-left{
  left: 28%;
}
.button-right{
  left: auto;
  right: 28%;
}
.mobile-container .button-left, 
.mobile-container .button-right{
  width: 22%;
  top: 37%;
}
.mobile-container .button-left{
  left: 23%;
}
.mobile-container .button-right{
  left: auto;
  right: 23%;
}
</style>
